import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { getReturnTo, setReturnTo } from "support/storage/supportStorage";

const PREFIX = "/dashboard/support";

// AuthGuard swaps OpenRoutes for PrivateRoutes wholesale on login, so a
// logged-out player who follows a link to a support thread does not get
// redirected to it after signing in, they get dropped wherever the logged-in
// tree happens to land. This remembers where they were heading and finishes the
// trip once they are through.
//
// It lives inside the router but outside both trees, because that swap is
// exactly the moment the intent would otherwise be lost.
export default function SupportReturnTo() {
  const location = useLocation();
  const history = useHistory();
  const isLoggedIn = useSelector((state) => state.userAuth.isAuthenticated);

  useEffect(() => {
    if (!isLoggedIn && location.pathname.indexOf(PREFIX) === 0) {
      setReturnTo(location.pathname);
    }
  }, [isLoggedIn, location.pathname]);

  useEffect(() => {
    if (!isLoggedIn) {
      return;
    }
    const target = getReturnTo();
    if (!target) {
      return;
    }
    setReturnTo(null);
    if (location.pathname !== target) {
      history.replace(target);
    }
  }, [isLoggedIn, location.pathname, history]);

  return null;
}
